module.exports = __webpack_public_path__ + "static/img/fish18.b8b4657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish18.png
// module id = qXmb
// module chunks = 0